import {PropertyBase} from "./PropertyBase";
import {EventManager} from "shared/core/Events/EventManager";
import {GetFormulaDialog} from "PDFImporter/Events/GetFormulaDialog";

export class FormulaProperty extends PropertyBase{
    SubRenderer(): React.ReactNode {
        return EventManager.Publish<GetFormulaDialog>('GetFormulaDialog',{
            FormulaName:'value',
            FieldSettings:this.Options,
            DocumentManager:this.fieldSettings.props.DocumentManager
        })
    }

}